import type { FC } from 'react';
import { Box, Typography } from '@mui/material';

interface ISecretWordProps {
	/** Inspection word badge text, e.g. "BIRKE". Renders nothing when empty. */
	secretWord?: string;
}

/** Inspection-word (LUMEN) badge. Shown only on active tickets. */
export const SecretWord: FC<ISecretWordProps> = ({ secretWord }) => {
	if (!secretWord) {
		return null;
	}

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: 72,
				mx: 3,
				borderRadius: '8px',
				border: (theme) => `1px solid ${theme.palette.primary[200]}`,
				bgcolor: 'solutions.50',
			}}
			data-testid="ticketshop-ticket-secret-word"
		>
			<Typography
				variant="h3-sb"
				color="primary.main"
				sx={{ letterSpacing: '0.2em' }}
			>
				{secretWord}
			</Typography>
		</Box>
	);
};
